import React from "react";
import styles from "./index.module.scss";
import classes from "classnames";
import Diamond from "../../icons/diamond";
import Popup from "../popup";

export interface DiamondsProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  value: number;
}

const Diamonds = ({ className, value }: DiamondsProps) => {
  return (
    <Popup
      className={classes(styles.diamonds, className)}
      content={
        <div className={styles.card}>
          <div className={styles["card-title"]}>你的钻石</div>
          <div className={styles["card-body"]}>
            <div className={styles["card-diamond"]}>
              <Diamond />
              {value}
            </div>
            <div className={styles["card-sub-title"]}>
              {"钻石能让你做很多有用的事情. \n保持每天学习去收集更多钻石！"}
            </div>
            <div className={styles["card-divider"]}></div>
            <div className={styles["card-diamond-how"]}>
              如何去获得更多钻石：
            </div>
            <div className={styles["card-line"]}>
              <span>完成一个课程小节</span>
              <span className={styles["card-diamond-count"]}>+ 10 钻石</span>
            </div>
            <div className={styles["card-line"]}>
              <span>完成一次编程练习</span>
              <span className={styles["card-diamond-count"]}>+ 10 钻石</span>
            </div>
          </div>
        </div>
      }
    >
      <div className={styles.button}>
        <div className={styles.icon} />
        <div className={styles.count}>{value}</div>
      </div>
    </Popup>
  );
};

export default Diamonds;
